const initialState = {
    text: '',
    isLoading: false,
    result: [],
};
const search = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_SEARCH_AUTOCOMPLETE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default search;
